import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const DeleteConfirmationModal = ({
  open,
  cancel,
  title,
  item,
  loading,
  handleDelete,
}) => {
  return (
    <Dialog open={open} onClose={cancel}>
      <DialogTitle>Delete {title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete <strong>{item}</strong>? This action
          cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;